// Registry frontend des widgets — mappe id du catalogue serveur vers
// composant React. La source de vérité reste backend (catalog.py) ;
// le registry ici ne fait qu'attribuer un composant à un id connu.
// Si le serveur renvoie un widget dont l'id n'est pas mappé ici,
// le composant fallback "WidgetUnknown" est utilisé (cf. WidgetCard).
import { WIDGETS_AMO, widgetMonte } from "./widgetsAmo";
import RecentDossiersWidget from "./sample/RecentDossiersWidget";
import AlertesAnahWidget from "./sample/AlertesAnahWidget";
import ShortcutWidget from "./sample/ShortcutWidget";

// Hub Finance — widgets extraits de DashboardFinance.jsx
import FinanceKpisWidget from "./finance/FinanceKpisWidget";
import FinancePipelineWidget from "./finance/FinancePipelineWidget";
import FinanceEvolutionWidget from "./finance/FinanceEvolutionWidget";
import FinanceVisitesAmoWidget from "./finance/FinanceVisitesAmoWidget";
import FinanceRecentDossiersWidget from "./finance/FinanceRecentDossiersWidget";
import FinanceVisitesSuiviWidget from "./finance/FinanceVisitesSuiviWidget";

// Hub Conformité — widgets extraits de DashboardConformite.jsx
import ConformiteKpisWidget from "./conformite/ConformiteKpisWidget";
import ConformitePipelineAnahWidget from "./conformite/ConformitePipelineAnahWidget";
import ConformitePipelineAvancesWidget from "./conformite/ConformitePipelineAvancesWidget";
import ConformiteEvolutionDepotsWidget from "./conformite/ConformiteEvolutionDepotsWidget";
import ConformiteMdphWidget from "./conformite/ConformiteMdphWidget";
import ConformiteParInstallateurWidget from "./conformite/ConformiteParInstallateurWidget";

// Hub Commercial — widgets extraits de DashboardPipelineCommercial.jsx
import CommercialKpisWidget from "./commercial/CommercialKpisWidget";
import CommercialDistributionFunnelWidget from "./commercial/CommercialDistributionFunnelWidget";
import CommercialFunnelGlobalWidget from "./commercial/CommercialFunnelGlobalWidget";
import CommercialTauxVisiteursWidget from "./commercial/CommercialTauxVisiteursWidget";
import CommercialVisiteursDetailWidget from "./commercial/CommercialVisiteursDetailWidget";

// Hub Opération — 5 widgets granulaires
import OperationKpisWidget from "./operation/OperationKpisWidget";
import OperationPipelineVisitesWidget from "./operation/OperationPipelineVisitesWidget";
import OperationEvolutionWidget from "./operation/OperationEvolutionWidget";
import OperationVisiteursWidget from "./operation/OperationVisiteursWidget";
import OperationInstallateursWidget from "./operation/OperationInstallateursWidget";

// Hub Communication — 4 widgets par canal
import CommunicationStatsWidget from "./communication/CommunicationStatsWidget";
import CommunicationAppelsWidget from "./communication/CommunicationAppelsWidget";
import CommunicationEmailsWidget from "./communication/CommunicationEmailsWidget";
import CommunicationSMSWidget from "./communication/CommunicationSMSWidget";

// Hub Gouvernance — 5 widgets extraits de GouvDashboard
import GouvGardiensWidget from "./governance/GouvGardiensWidget";
import GouvPerimetresWidget from "./governance/GouvPerimetresWidget";
import GouvTicketsWidget from "./governance/GouvTicketsWidget";
import GouvEvaluationsWidget from "./governance/GouvEvaluationsWidget";
import GouvSystemHealthWidget from "./governance/GouvSystemHealthWidget";

// T-181 — tableau de bord par tenant
import IndicateursWidget from "./tableau_bord/IndicateursWidget";

export const WIDGET_COMPONENTS = {
  tableau_bord_indicateurs:  IndicateursWidget,

  // Génériques
  recent_dossiers:           RecentDossiersWidget,
  alertes_anah:              AlertesAnahWidget,
  shortcut_nouveau_dossier:  ShortcutWidget,

  // Hub Finance
  finance_kpis:              FinanceKpisWidget,
  finance_pipeline:          FinancePipelineWidget,
  finance_evolution:         FinanceEvolutionWidget,
  finance_visites_amo:       FinanceVisitesAmoWidget,
  finance_recent_dossiers:   FinanceRecentDossiersWidget,
  finance_visites_suivi:     FinanceVisitesSuiviWidget,

  // Hub Conformité
  conformite_kpis:                 ConformiteKpisWidget,
  conformite_pipeline_anah:        ConformitePipelineAnahWidget,
  conformite_pipeline_avances:     ConformitePipelineAvancesWidget,
  conformite_evolution_depots:     ConformiteEvolutionDepotsWidget,
  conformite_mdph:                 ConformiteMdphWidget,
  conformite_par_installateur:     ConformiteParInstallateurWidget,

  // Hub Commercial
  commercial_kpis:                 CommercialKpisWidget,
  commercial_distribution_funnel:  CommercialDistributionFunnelWidget,
  commercial_funnel_global:        CommercialFunnelGlobalWidget,
  commercial_taux_visiteurs:       CommercialTauxVisiteursWidget,
  commercial_visiteurs_detail:     CommercialVisiteursDetailWidget,

  // Hub Opération
  operation_kpis:               OperationKpisWidget,
  operation_pipeline_visites:   OperationPipelineVisitesWidget,
  operation_evolution:          OperationEvolutionWidget,
  operation_visiteurs:          OperationVisiteursWidget,
  operation_installateurs:      OperationInstallateursWidget,

  // Hub Communication
  communication_stats:          CommunicationStatsWidget,
  communication_appels:         CommunicationAppelsWidget,
  communication_emails:         CommunicationEmailsWidget,
  communication_sms:            CommunicationSMSWidget,

  // Hub Gouvernance
  gouv_gardiens:        GouvGardiensWidget,
  gouv_perimetres:      GouvPerimetresWidget,
  gouv_tickets:         GouvTicketsWidget,
  gouv_evaluations:     GouvEvaluationsWidget,
  gouv_system_health:   GouvSystemHealthWidget,
};

export { WIDGETS_AMO, widgetMonte };

// Mapping "size" → classes Tailwind grid (12-col layout sur md+, 1 col mobile)
export const SIZE_TO_COLSPAN = {
  sm: "md:col-span-3",
  md: "md:col-span-4",
  lg: "md:col-span-6",
  xl: "md:col-span-12",
};
